import React, { useContext, useMemo } from 'react'
import { Grid, GridCell, Text, View } from 'oio-react'
import { useParams } from 'react-router-dom'
import { initiativeUrl } from 'config/constants/urls'
import ContainerBlock from 'src/apps/CustomApp/blocks/Container'
import LayoutContainer from 'src/apps/CustomApp/components/LayoutContainer'
import Title from 'src/apps/CustomApp/components/Title'
import Titlebar from 'src/apps/CustomApp/components/Titlebar'
import InitiativeCreateControl from 'src/apps/Initiative/components/CreateControl'
import InitiativeList from 'src/apps/Initiative/components/List'
import { useOrganization } from 'src/graphql/hooks'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'
import BlogListItemCard from '~/components/ListItemCard'

const BlogHome = () => {
   const { initiativeTypeSlug } = useParams()
   const { protoTheme: theme } = useContext(ProtoThemeContext)
   const { organization } = useOrganization()
   const postTypes = organization.initiativeTypes.filter(t => t.class === 'post' && t.enabled)

   // If there is an initiativeTypeSlug, show only events of that type
   // Otherwise, we assume it is a full Events app and show all events of
   // any initiative type
   const initiativeTypes = useMemo(() => {
      if (initiativeTypeSlug) {
         const initiativeType = organization.initiativeTypes
            .find(type => type.slug === initiativeTypeSlug)

         if (initiativeType) {
            return [initiativeType]
         }
      }

      return organization.initiativeTypes
         .filter(type => type.enabled && type.class === 'post')
   }, [organization.initiativeTypes, initiativeTypeSlug])

   const initiativeTypeIds = initiativeTypes.map(type => type.id)
   const appTitle = initiativeTypeSlug && initiativeTypes[0]
      ? initiativeTypes[0].namePlural
      : 'Blog'

   const initiativeListFilter = {
      archived: 'exclude',
      drafts: 'include',
      sortBy: 'dateLastUpdated',
      typeIds: initiativeTypeIds,
      limit: 12
   }

   return (
      <LayoutContainer>
         <ContainerBlock>
            <Titlebar>
               <Title color={theme.tmpContentTitleColor}>{appTitle}</Title>
               <InitiativeCreateControl initiativeTypes={postTypes} />
            </Titlebar>
            <Grid columns="1" spacing="0px">
               <InitiativeList
                  emptyContent={(
                     <GridCell>
                        <View
                           width="100%"
                           padding="30px 0px 50px 0px">
                           <Text size="2" color="#888">
                              There are no articles to show
                           </Text>
                        </View>
                     </GridCell>
                  )}
                  filter={initiativeListFilter}>
                  {initiativeList => initiativeList.items.map(initiative => (
                     <GridCell key={initiative.id}>
                        <BlogListItemCard
                           bodyTextColor={theme.tmpNavTextColor}
                           bodyTextSize={theme.tmpBodyTextSize}
                           borderStyle={`1px solid ${theme.tmpBorderColor}`}
                           coverUrl={initiative.coverMedia?.file.thumbnailUrlW480}
                           dateAdded={initiative.dateAdded}
                           linkTo={initiativeUrl(initiative)}
                           name={initiative.name}
                           numThreadEntries={initiative.thread.numEntries}
                           numViews={initiative.numViews}
                           privacy={initiative.privacy}
                           subtitle={initiative.subtitle}
                           summary={initiative.body.summary}
                           textColor={theme.tmpTitleColor}
                        />
                     </GridCell>
                  ))}
               </InitiativeList>
            </Grid>
         </ContainerBlock>
      </LayoutContainer>
   )
}

export default BlogHome
